module.exports = __webpack_public_path__ + "static/media/fill-warning.9e2179f7.svg";